module.exports = __webpack_public_path__ + "img/timofeev.a3b6cc8f.jpg";